import { Component, OnInit, NgModule, Input, Output, EventEmitter } from '@angular/core';
import { Routes, RouterModule, Router, ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DxButtonModule, DxTextBoxModule, DxFormModule, DxTooltipModule } from 'devextreme-angular';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from '../../services/common.service';
import { ToastrService } from 'ngx-toastr';
import { BaseRequestService } from '../../services/base-request.service';
import { APIConfing } from '../../services/apiconfing.service';
import { CommonPreLoadedService } from 'src/app/core/services/common/common-pre-loaded.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { CoreModule } from 'src/app/core/core.module';
import { EncryptDecryptService } from '../../services/encrypt-decrypt.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  standalone: false
})
export class ForgotPasswordComponent implements OnInit {
  @Input() validEmailInfo: any;
  @Output() emitPassRes = new EventEmitter<any>();
  spinnerProp: any = {
    bdColor: '',
    fullScreen: false,
    size: '',
    color: '',
    type: ''
  };
  spinnerForgot = 'forgot';
  // validEmailInfo: any;
  errMsg: string;
  emailIDpattern: string;
  forgotPasswordModel: any = {

    consEmailID: null
  };
  essForgotPassword: any = {
    text: 'Reset',
    useSubmitBehavior: true,
    width: '100%',
    icon: '',
    type: 'success'
  };
  commonPatter: any = /^(\d{10}|\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4}))$/;
  isSubLogo: any;
  getImgLogo: any;
  isShowImgLogo: boolean;

  constructor(private router: Router, private route: ActivatedRoute, public common: CommonService,
    private toastrService: ToastrService, private commonAPI: CommonPreLoadedService,
    private baseRequset: BaseRequestService, private spinner: NgxSpinnerService,
    private enc: EncryptDecryptService) {
    this.spinnerProp.bdColor = APIConfing.data.spinnerProp.bdColor;
    this.spinnerProp.fullScreen = APIConfing.data.spinnerProp.fullScreen;
    this.spinnerProp.size = APIConfing.data.spinnerProp.size;
    this.spinnerProp.color = APIConfing.data.spinnerProp.color;
    this.spinnerProp.type = APIConfing.data.spinnerProp.type;
    this.emailIDpattern = this.common.emailIDPattren;
    // this.route.queryParams
    //   .subscribe(params => {
    //     this.validEmailInfo = {
    //       consEmailID: atob(params.consEmailID),
    //       consultantID: atob(params.consultantID),
    //       cid: atob(params.cid)
    //     };

    this.isSubLogo = this.commonAPI.getCustomerLogo$().pipe(catchError(err => throwError(err)))
      .subscribe(obj => {
        if (obj && obj.length > 0) {
          this.getImgLogo = obj[0].logoURL;
          this.isShowImgLogo = true;
          this.commonAPI.customerLogo.next(null);
        } else if (obj && obj.length === 0) {
          this.isShowImgLogo = false;
          this.getImgLogo = null;
        }
      });
  }

  ngOnInit() {
    if (this.validEmailInfo && this.validEmailInfo.consEmailID) {
      this.forgotPasswordModel.consEmailID = this.validEmailInfo.consEmailID;
      this.forgotPasswordModel.consultantID = this.validEmailInfo.consultantID;
      this.errMsg = null;
      //   });
      if (this.validEmailInfo.cid > 0) {
        // this.commonAPI.fnGetCustomerLogoURL(this.validEmailInfo.cid, 1);
        this.getImgLogo = localStorage.getItem(this.enc.encryptUsingAES256('customerLogoURL'));
        this.isShowImgLogo = true;
      } else {
        this.isShowImgLogo = false;
      }
    }
    else {
      this.router.navigate(['/login']);
    }
  }

  fnForgotPassword(data: any) {
    this.spinner.show(this.spinnerForgot);
    data.cid = parseInt(this.validEmailInfo.cid) || 0;
    this.forgotPasswordModel.route = 'Verify-Account';
    this.validEmailInfo.route = 'Verify-Account';
    this.baseRequset.fnpost('/CSS/Consultant/ForgotConsultantPasswd', this.common.fnReturnEncryptedPayload(data))
      .subscribe((dataRESP: any) => {
        if (dataRESP && dataRESP.code === this.common.status.success) {
          // this.toastrService.success(dataRESP.message, 'Success');
          this.validEmailInfo.msg = dataRESP.message || '';
          this.forgotPasswordModel.msg = dataRESP.message || '';
          if (this.validEmailInfo && this.validEmailInfo.cliConEmailID
            && this.validEmailInfo.clientContactID >= 0 && this.validEmailInfo.cid) {
            // this.router.navigate(['/Verify-Account'],
            //   { queryParams: { verifyAccount: btoa(JSON.stringify(this.validEmailInfo)) } });           
            this.emitPassRes.emit(this.validEmailInfo);
          } else {
            // this.router.navigate(['/Verify-Account'],
            //   { queryParams: { verifyAccount: btoa(JSON.stringify(this.forgotPasswordModel)) } });
            this.emitPassRes.emit(this.forgotPasswordModel);
          }
          this.spinner.hide(this.spinnerForgot);
        } else if (dataRESP.code === 'E002') {
          this.toastrService.error(APIConfing.data.E002);
          this.spinner.hide(this.spinnerForgot);
        } else if (dataRESP.code === 'E001') {
          this.toastrService.error(dataRESP.message, 'Error');
          this.spinner.hide(this.spinnerForgot);
          this.errMsg = dataRESP.message;
        } else if (dataRESP.code === this.baseRequset.warning.code) {
          this.toastrService.warning(dataRESP.message, 'Details');
          this.spinner.hide(this.spinnerForgot);
          this.errMsg = dataRESP.message;
        } else {
          this.errMsg = dataRESP.message;
          this.spinner.hide(this.spinnerForgot);
        }
      }, err => {
        this.toastrService.error(APIConfing.data.E002);
        this.spinner.hide(this.spinnerForgot);
      });
  }

  fnAlreadyPassword() {
    // this.router.navigate(['/login'],
    //   {
    const queryParams = {
      userName: this.validEmailInfo.consEmailID, cid: this.validEmailInfo.cid,
      consultantID: this.validEmailInfo.consultantID,
      route: 'Login'
    }
    this.emitPassRes.emit(queryParams);
    // });
  }
}
const routes: Routes = [
  { path: '', component: ForgotPasswordComponent }
];
@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    // DxButtonModule,
    // DxTextBoxModule,
    DxFormModule,
    FormsModule,
    // DxTooltipModule,
    NgxSpinnerModule,
    CoreModule
  ],
  declarations: [ForgotPasswordComponent],
  exports: [RouterModule, ForgotPasswordComponent]
})
export class ForgotPasswordVerifyModule { }
